import React, { useState } from 'react';
import { Grid, Typography, Button, Collapse, Card, CardContent, Paper, Stepper, Step, StepLabel, StepContent, MobileStepper } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import Line from '../images/line.png';
import Portfolio1 from '../images/portfolio1.png';
import Portfolio2 from '../images/portfolio2.png';
import Portfolio3 from '../images/portfolio3.png';
import Portfolio4 from '../images/portfolio4.png';
import Portfolio5 from '../images/portfolio5.png';
import { makeStyles } from '@material-ui/core/styles';
import showcaseLaptop from '../images/Copilot_20251021_151902_v2.png';
import CEMark from '../images/CE_mark.png';
import GDPRcompliant_logoGrey from '../images/GDPR-compliant-logo-Grey.png';
import GDPRMark from '../images/gdpr.png';
import DanishHealth from '../images/Danish_Health_Authority.png';

const faqs = [
    {
        q: "How do I get started with VIRTUS™ Clinic for my clinic?",
        a: "Simply contact us for a demo and onboarding. We'll help you set up your clinic, invite your team, and start assigning patients right away."
    },
    {
        q: "Is VIRTUS™ Clinic compliant with healthcare regulations?",
        a: "Yes, VIRTUS™ Clinic is CE-approved, GDPR compliant, and designed for safe, secure patient care."
    },
    {
        q: "Can I use VIRTUS™ Clinic for both in-person and remote care?",
        a: "Absolutely! VIRTUS™ Clinic supports hybrid care models, allowing you to combine in-clinic and telehealth services."
    },
    {
        q: "How does VIRTUS™ Clinic help with documentation?",
        a: "Our platform automates much of the documentation process, generating digital journals and reports for each patient, saving you time and reducing errors."
    },
    {
        q: "What support is available for clinics?",
        a: "We offer onboarding, training, and ongoing support to ensure your clinic gets the most out of VIRTUS™ Clinic."
    },
];

const useStyles = makeStyles((theme) => ({
    sloganSection: {
        width: '100%',
        margin: '100px auto 32px auto',
        background: 'transparent',
        borderRadius: 16,
        padding: '32px 0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    complianceBanner: {
        width: '100vw',
        maxWidth: '100vw',
        position: 'relative',
        background: 'rgba(255,255,255,0.15)',
        borderRadius: 0,
        padding: '12px 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 48,
        boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
        marginBottom: 58,
        zIndex: 50,
    },
    complianceLogo: {
        height: 48,
        width: 'auto',
        opacity: 0.98,
        [theme.breakpoints.down('sm')]: {
            height: 40,
        },
        [theme.breakpoints.up('md')]: {
            height: 55,
        },
        [theme.breakpoints.up('lg')]: {
            height: 92,
        },
    },
    complianceLogo2: {
        height: 'auto',
        width: 'auto',
        opacity: 0.98,
        [theme.breakpoints.down('sm')]: {
            height: 27,
        },
        [theme.breakpoints.up('md')]: {
            height: 30,
        },
        [theme.breakpoints.up('lg')]: {
            height: 45,
        },
    },
    benefitImageGrid: {
        background: '#fff',
        borderRadius: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 180,
        margin: 10,
        boxShadow: '0 4px 24px 0 rgba(60,60,60,0.10)',
    },
    benefitImage: {
        width: '95%',
        maxWidth: 340,
        minWidth: 180,
        height: 'auto',
        borderRadius: 16,
        objectFit: 'cover',
        alignSelf: 'center',
        background: '#f5f7fa',
    },
    benefitTextGrid: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'left',
        padding: '24px 32px',
        minHeight: 180,
    },
    benefitTextBox: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '24px 32px',
    },
    benefitHeadline: {
        color: '#002D55',
        fontWeight: 600,
        textAlign: 'left',
        maxWidth: 600,
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.1rem',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.3rem',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '1.4rem',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '1.6rem',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '1.8rem',
        },
    },
    benefitLine: {
        width: 80,
        margin: '0px 0 8px 0',
    },
    benefitText: {
        color: '#324158',
        fontWeight: 400,
        textAlign: 'left',
        maxWidth: 600,
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.9rem',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.0rem',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '1.1rem',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '1.2rem',
        },
    },
    root: {
        flexGrow: 1,
    },
    section: {
        background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)',
        borderRadius: 16,
        boxShadow: '0 4px 24px 0 rgba(60,60,60,0.12)',
        border: '1px solid #e0e0e0',
        maxWidth: 1200,
        width: '96%',
        margin: '32px auto',
        padding: 36,
    },
    section2: {
        background: 'transparent',
        //boxShadow: '0 4px 24px 0 rgba(60,60,60,0.12)',
        //border: '1px solid #e0e0e0',
        maxWidth: "100%",
        width: '100%',
        margin: '32px auto',
        padding: 36,
        width: '100vw',
        maxWidth: '100vw',
        position: 'relative',
        borderRadius: 0,
        padding: '8px 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 58,
        //boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
        marginBottom: 48,
        zIndex: 50,
        marginTop: 0
    },
    headline: {
        color: '#002D55',
        fontWeight: 600,
        marginBottom: 12,
        textAlign: 'left',
        maxWidth: 700,
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.3rem',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.3rem',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '1.5rem',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '1.8rem',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '2rem',
        },
    },
    subheadline: {
        color: '#324158',
        fontWeight: 400,
        marginBottom: 8,
        textAlign: 'left',
        maxWidth: 600,
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.0rem',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.0rem',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '1.1rem',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '1.4rem',
        },
    },
    sloganHeadline: {
        color: '#002D55',
        fontWeight: 600,
        marginBottom: 24,
        textAlign: 'center',
        maxWidth: 900,
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.3rem',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.3rem',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '1.5rem',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '1.8rem',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '2rem',
        },
    },
    buttonRow: {
        display: 'flex',
        flexDirection: 'row',
        gap: 12,
        marginTop: "1.5%",
        marginBottom: 24,
        alignItems: 'center',
    },
}));





export default function ClinicContent() {
    const classes = useStyles();
    // FAQ expand/collapse state
    const [openFaq, setOpenFaq] = useState(null);
    // Stepper state for 'Scaling your care team' section
    const [activeStep, setActiveStep] = useState(0);
    // overlay buttons (always visible)
    const [selectedOverlay, setSelectedOverlay] = useState('Remote physio monitoring');

    const benefits = [
        {
            image: Portfolio1,
            headline: 'Normal care staff is qualified to initiate assessments and rehabilitation programs',
            text: 'Use guided, computer-vision assessments that allow nurses and helpers to initiate clinically valid screenings together with elderly patients with a remote physio on-standby.'
        },
        {
            image: Portfolio4,
            headline: 'The right digital home exercise program — that adapts by itself ',
            text: 'Care staff can choose adaptive home exercise programs tailored to each patient. Programs update automatically based on patient symptom response and feedback - with a remote physio on standby.'
        },
        {
            image: Portfolio1,
            headline: 'Support completion together or let patients self-manage',
            text: 'Care staff can complete exercises alongside the elderly patient or enable the patient to do them independently, with remote monitoring and automatic progress capture.'
        },
        {
            image: Portfolio3,
            headline: 'Hire a virtual physiotherapist & enable hybrid care',
            text: 'Hire a virtual physiotherapist through VIRTUS CARE™ to remotely supervise and support your on-site care staff. Implement a hybrid care setup that combines in-person support with remote clinical expertise.'
        },
        {
        image: Portfolio5,
        headline: 'Automatic documentation and alerts — with a remote physio on standby.',
        text: 'All assessments, exercise activity and outcomes are documented automatically. Staff receive notifications when clinical escalation or physio input is required.'
    },
    {
        image: Portfolio2,
        headline: 'Compliant and secure for eldercare',
        text: 'VIRTUS CARE™ is CE-approved and GDPR-compliant, built to help eldercare providers meet regulatory requirements such as the Ældreplejelov while scaling care capacity.'
    },
];

    // Custom step icon renderer: circular orange background with white number/check
    const CustomStepIcon = (props) => {
        const { active, completed, icon } = props;
        const size = 34;
        const baseStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: size,
            height: size,
            borderRadius: '50%',
            background: '#fb741a',
            color: '#fff',
            fontWeight: 700,
            boxShadow: active ? '0 6px 18px rgba(0,0,0,0.16)' : 'none',
            fontSize: 14,
        };
        return (
            <div style={baseStyle} aria-hidden>
                {completed ? <CheckIcon style={{ fontSize: 18, color: '#fff' }} /> : <span>{icon}</span>}
            </div>
        );
    };
    // Responsive drawers for subheadline benefits
    const subheadlineBenefits = [
        {
            key: 'qualifyStaff',
            icon: <span role="img" aria-label="train">🎓</span>,
            label: <div style={{marginLeft: 0}}>Our technology qualifies care staff to initiate rehabilitation programs</div>,
            drawer: <div style={{marginLeft: "-3%"}}>Train nurses and helpers to complete computer-vision guided assessments and select appropriate digital home exercise programs together with the patient.</div>
        },
        {
            key: 'supportOrSelfManage',
            icon: <span role="img" aria-label="support">🤝</span>,
            label: "Care staff can train with patients or enable self-management",
            drawer: "Care staff can complete exercises alongside the elderly patient or enable self-management, with automatic monitoring and remote physio adjustments as needed."
        },
        {
            key: 'docsAlerts',
            icon: <span role="img" aria-label="doc">🖥️</span>,
            label: 'Automatic documentation & alerts',
            drawer: 'All assessments and activities are documented automatically and staff are notified when escalation or physio input is necessary.'
        },
        {
            key: 'hirePhysio',
            icon: <span role="img" aria-label="physio">👨‍⚕️</span>,
            label: <div style={{marginLeft: 0}}>Hire a virtual physiotherapist in a hybrid care setup</div>,
            drawer: <div style={{marginLeft: "-3%"}}>Bring remote physiotherapists into your care pathway to supervise assessments, review progress and support care staff when clinical input is required.</div>
        },
        {
            key: 'compliance',
            icon: <span role="img" aria-label="shield">🛡️</span>,
            label: 'GDPR Compliant and secure for eldercare',
            drawer: 'Registered as a medical device and designed to meet GDPR requirements and to support compliance with regulations such as the Ældreplejelov.'
        },
    ];
    const [openBenefit, setOpenBenefit] = useState(null);

    return (
        <Grid container justifyContent="center" direction="column" alignItems="center" className={classes.root} style={{width: '100%', margin: 'auto', paddingLeft: 16, paddingRight: 16}}>
            <Grid container item xs={12} style={{ margin: '20px auto 20px', width: '100%', maxWidth: 2100 }} direction="row" justifyContent="center" alignItems="center">
                <Grid item xs={12} md={6} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', minWidth: 320, marginTop: 0, paddingLeft: "4%" }}>
                    <Typography variant="h4" className={classes.headline} style={{ marginLeft: 0, marginTop: 45, maxWidth: 700 }}>
                        Qualify your care staff to deliver collaborative or self-managed digital rehabilitation for eldercare with VIRTUS CARE<sup style={{fontSize: '0.7em', verticalAlign: 'super'}}>™</sup>
                    </Typography>
                    {/* Responsive drawers for subheadline benefits styled like Maincontent.js */}
                    <ul style={{listStyle: 'none', paddingLeft: 0, marginBottom: 5, marginTop: 5, minWidth: 300, width: '100%', maxWidth: 750}}>
                        {subheadlineBenefits.map((benefit, idx) => (
                            <li key={benefit.key} style={{marginBottom: 10, display: 'flex', alignItems: 'baseline', borderRadius: 32}}>
                                <span
                                    style={{
                                        fontSize: '1.3rem',
                                        display: 'inline-block',
                                        verticalAlign: 'baseline',
                                        marginRight: 10,
                                    }}
                                    className="subheadline-icon-responsive"
                                >
                                    {benefit.icon}
                                </span>
                                <span style={{position: 'relative', cursor: 'pointer', flex: 1}}>
                                    <b
                                        onClick={() => setOpenBenefit(openBenefit === idx ? null : idx)}
                                        style={{
                                            transition: 'color 0.2s',
                                            userSelect: 'none',
                                            color: openBenefit === idx ? '#4a6fa3' : '#002D55',
                                            fontSize: '1.05rem',
                                            fontWeight: 400,
                                        }}
                                        className="subheadline-label-responsive"
                                    >{benefit.label}</b>
                                    {openBenefit === idx && (
                                        <div
                                            className="subheadline-drawer-responsive"
                                            style={{
                                                position: 'relative',
                                                marginTop: 8,
                                                background: 'transparent',
                                                color: '#002D55',
                                                padding: '1px 8px 4px 8px',
                                                borderRadius: 0,
                                                boxShadow: 'none',
                                                fontSize: '0.99rem',
                                                maxWidth: 420,
                                                zIndex: 1,
                                                border: 'none',
                                                opacity: 1,
                                                transition: 'opacity 0.3s',
                                            }}
                                        >
                                            {benefit.drawer}
                                        </div>
                                    )}
                                </span>
                            </li>
                        ))}
                    </ul>
                    <style>{`
                        @media (max-width: 600px) {
                            .subheadline-icon-responsive { font-size: 0.9rem !important; }
                            .subheadline-label-responsive { font-size: 0.85rem !important; }
                            .subheadline-drawer-responsive { font-size: 0.80rem !important; }
                        }
                        @media (min-width: 600px) and (max-width: 960px) {
                            .subheadline-icon-responsive { font-size: 0.95rem !important; }
                            .subheadline-label-responsive { font-size: 0.90rem !important; }
                            .subheadline-drawer-responsive { font-size: 0.84rem !important; }
                        }
                        @media (min-width: 960px) and (max-width: 1280px) {
                            .subheadline-icon-responsive { font-size: 1.0rem !important; }
                            .subheadline-label-responsive { font-size: 0.95rem !important; }
                            .subheadline-drawer-responsive { font-size: 0.88rem !important; }
                        }
                        @media (min-width: 1280px) and (max-width: 1920px) {
                            .subheadline-icon-responsive { font-size: 1.15rem !important; }
                            .subheadline-label-responsive { font-size: 1.09rem !important; }
                            .subheadline-drawer-responsive { font-size: 0.92rem !important; }
                        }
                        @media (min-width: 1920px) {
                            .subheadline-icon-responsive { font-size: 1.25rem !important; }
                            .subheadline-label-responsive { font-size: 1.18rem !important; }
                            .subheadline-drawer-responsive { font-size: 0.95rem !important; }
                        }
                    `}</style>
                    <div className={classes.buttonRow}>
                        <Button
                            variant="contained"
                            style={{ background: '#fb741a', color: '#fff', fontWeight: 600, fontSize: 18, padding: '10px 32px', borderRadius: 8 }}
                            href="#contact"
                        >
                            Sign up
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ background: '#9f9d9cff', color: '#fff', fontWeight: 600, fontSize: 18, padding: '10px 32px', borderRadius: 8 }}
                            href="#contact"
                        >
                            Book a Demo
                        </Button>
                    </div>
                    {/* Compliance banner centered below overlays */}
                        <div className={classes.section2} style={{ width: '100%', display: 'flex', justifyContent: 'left', alignItems: 'center', marginTop: '1.5%', paddingTop: 0, marginRight: "8%" }}>
                            <img src={CEMark} alt="CE mark" className={classes.complianceLogo2} />
                            <img src={GDPRcompliant_logoGrey} alt="GDPR" className={classes.complianceLogo} style={{ paddingLeft: '4%' }} />
                            <img src={DanishHealth} alt="Danish Health Authority" className={classes.complianceLogo} />
                        </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} style={{ background: "transparent", display: 'flex', justifyContent: 'center', alignItems: 'flex-start', minHeight: 0 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', minHeight: 600, position: 'relative', gap: 0, paddingTop: "0%"}}>
                        <img
                            src={showcaseLaptop}
                            alt="VirtusPhysio Clinic Mockup"
                            style={{ maxWidth: '100%', maxHeight: 470, minHeight: 300, minWidth: 390, borderRadius: 18, marginTop: 0, marginBottom: 0 }}
                        />

                        {/* overlay buttons - now in normal flow, centered below image */}
                        <style>{`
                            .overlayButton { transition: transform 180ms ease, opacity 180ms ease; transform-origin: center; font-size: 15px; padding: 10px 14px; }
                            .overlayButton:hover { transform: scale(1.33); }
                            .overlayButton.selected { transform: scale(1.33); }

                            /* Responsive sizing */
                            @media (max-width: 1280px) {
                                .overlayButton { font-size: 11px; padding: 7px 10px; }
                            }
                            @media (max-width: 960px) {
                                .overlayButton { font-size: 12px; padding: 10px 14px; }
                            }
                            @media (max-width: 600px) {
                                .overlayButton { font-size: 10px; padding: 5px 8px; }
                            }
                            @media (max-width: 400px) {
                                .overlayButton { font-size: 9px; padding: 4px 7px; }
                            }
                        `}</style>
                        <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', margin: '2% 0 0 0', position: 'relative', minHeight: 120 }}>
                            {/* Overlay buttons in a cone layout, but in flex flow */}
                            {[
                                { label: 'Motion capture assessment' },
                                { label: 'Automated journaling & reports' },
                                { label: 'Automated exercise delivery' },
                                { label: 'Home exercise builder' },
                                { label: 'Patient monitoring' },
                                { label: 'Video consultations' },
                                { label: 'Chat function' },
                                { label: 'Calendar' },
                                { label: 'Online payments' },
                                { label: 'Staff admin' },
                            ].map((btn, idx) => (
                                <button
                                    key={idx}
                                    onClick={() => setSelectedOverlay(btn.label === selectedOverlay ? null : btn.label)}
                                    className={`overlayButton${btn.label === selectedOverlay ? ' selected' : ''}`}
                                    style={{
                                        background: 'rgba(255,255,255,0.22)',
                                        color: '#002D55',
                                        border: '1px solid rgba(255,255,255,0.25)',
                                        borderRadius: 99,
                                        cursor: 'pointer',
                                        fontWeight: 600,
                                        backdropFilter: 'blur(6px)',
                                        boxShadow: '0 6px 18px rgba(0,0,0,0.52)',
                                        whiteSpace: 'nowrap',
                                        opacity: 0.98,
                                        margin: '8px 12px',
                                    }}
                                >
                                    {btn.label}
                                </button>
                            ))}
                        </div>

                        
                    </div>
                </Grid>
            </Grid>

            {/* Slogan/Benefits Section */}
            <Grid item xs={12} className={classes.sloganSection}>
                
                <Typography variant="h5" className={classes.sloganHeadline} style={{ marginBottom: 80, borderBottom: '2px solid #ccc', paddingTop: 24 }}>
                    Short on care staff for rehabilitative services? <br /> VIRTUS CARE™ can help — while you stay compliant
                </Typography>
                {benefits.map((benefit, idx) => (
                    <Grid container direction="row" xs={11} justify="center" key={idx} style={{
                        marginBottom: 16,
                        background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)',
                        borderRadius: 16,
                        boxShadow: '0 6px 18px rgba(0,0,0,0.52)',
                        border: '1px solid #e0e0e0',
                        width: "95%",
                        maxWidth: 1800,
                        minHeight: 0,
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    }}>
                        <Grid item xs={11} md={5} className={classes.benefitImageGrid}>
                            <img src={benefit.image} alt={benefit.headline} className={classes.benefitImage} />
                        </Grid>
                        <Grid item xs={12} md={6} className={classes.benefitTextGrid}>
                            <div className={classes.benefitHeadline}>
                                {benefit.headline.split('\n').map((line, idx) => (
                                    <React.Fragment key={idx}>
                                        {line}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </div>
                            <img src={Line} alt="divider" className={classes.benefitLine} />
                            <div className={classes.benefitText}>
                                {benefit.text.split('\n').map((line, idx) => (
                                    <React.Fragment key={idx}>
                                        {line}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </div>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
            {/* Testimonial/Quote Section */}
            <Grid item xs={12} style={{ maxWidth: 900, margin: '0 auto 32px auto', padding: 0 }}>
                <Card elevation={2} style={{ background: '#f5f7fa', borderLeft: '6px solid #002D55' }}>
                    <CardContent>
                        <Typography variant="h6" style={{ color: '#002D55', fontWeight: 500, fontStyle: 'italic', marginBottom: 8 }}>
                            “VirtusPhysio has transformed the way we deliver care - we went from a local clinic to a country-wide digital-first practice. Our patients love the convenience, and our team saves hours every week!”
                        </Typography>
                        <Typography variant="body2" style={{ color: '#324158', fontWeight: 400, textAlign: 'right' }}>
                            — Clinic Owner, Copenhagen
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            {/*<Grid item xs={12} className={classes.section} style={{ color: '#324158', fontSize: 18, maxWidth: 900, margin: '32px auto', paddingLeft: 24 }}>
                <Typography variant="h5" className={classes.headline}>
                    Key Benefits for Clinics & Physios
                </Typography>
                <ul style={{ color: '#324158', fontSize: 18, maxWidth: 900, margin: '32px auto', paddingLeft: 24 }}>
                    <li>Offer remote consultations and follow-ups to increase patient access and satisfaction.</li>
                    <li>Automate exercise program delivery and progress tracking for every patient.</li>
                    <li>Reduce administrative workload with digital documentation and reporting.</li>
                    <li>Monitor patient adherence and outcomes in real-time.</li>
                    <li>Expand your reach beyond the clinic with secure, user-friendly telehealth tools.</li>
                    <li>Boost clinic revenue with scalable digital services.</li>
                </ul>
            </Grid>*/}

            <Grid item xs={12} className={classes.section} style={{ color: '#324158', fontSize: 18, maxWidth: 900, margin: '32px auto', paddingLeft: 24, boxShadow: '0 6px 18px rgba(0,0,0,0.52)' }}>
                <Typography variant="h5" style={{ textAlign: 'center', width: '100%', color: '#002D55', fontWeight: 600, marginBottom: 12 }}>
                    Up-qualify your care team and deliver collaborative eldercare with ease
                </Typography>
                {/* Stepper replacing the static ordered list */}
                <div style={{ color: '#324158', fontSize: 18, maxWidth: 900, margin: '24px auto', paddingLeft: 0 }}>
                    <style>{`@media (max-width: 800px) { .desktop-stepper { display: none !important; } .mobile-stepper { display: block !important; } } @media (min-width: 800px) { .mobile-stepper { display: none !important; } }`}</style>

                    {/* Desktop vertical stepper */}
                    <div className="desktop-stepper" style={{ display: 'block' }}>
                        <Stepper activeStep={activeStep} orientation="vertical" style={{ background: 'transparent' }}>
                            <Step>
                                <StepLabel StepIconComponent={CustomStepIcon}>Register and onboard your care team in minutes to start collaborative assessments with elderly patients.</StepLabel>
                                <StepContent>
                                    <Typography style={{ color: '#324158' }}>Set up your facility, invite your care staff, and configure your services. Begin collaborative assessments with elderly patients, supported by remote physio expertise.</Typography>
                                    <div style={{ marginTop: 8 }}>
                                        <Button disabled={activeStep === 0} onClick={() => setActiveStep((s) => Math.max(0, s - 1))} style={{ marginRight: 8, background: '#002D55', color: '#fff' }}>Back</Button>
                                        <Button variant="contained" onClick={() => setActiveStep((s) => Math.min(4, s + 1))} style={{ background: '#002D55', color: '#fff' }}>Next</Button>
                                    </div>
                                </StepContent>
                            </Step>
                            <Step>
                                <StepLabel StepIconComponent={CustomStepIcon}>Complete collaborative assessments with care staff and elderly patients.</StepLabel>
                                <StepContent>
                                    <Typography style={{ color: '#324158' }}>Care personnel and elderly patients work together to complete digital assessments, capturing all relevant needs and symptoms. Remote physios review and support care planning.</Typography>
                                    <div style={{ marginTop: 8 }}>
                                        <Button onClick={() => setActiveStep((s) => Math.max(0, s - 1))} style={{ marginRight: 8, background: '#002D55', color: '#fff' }}>Back</Button>
                                        <Button variant="contained" onClick={() => setActiveStep((s) => Math.min(4, s + 1))} style={{ background: '#002D55', color: '#fff' }}>Next</Button>
                                    </div>
                                </StepContent>
                            </Step>
                            <Step>
                                <StepLabel StepIconComponent={CustomStepIcon}>Deliver adaptive activity and exercise programs tailored for eldercare.</StepLabel>
                                <StepContent>
                                    <Typography style={{ color: '#324158' }}>Programs adapt to feedback and progress, with care staff supporting daily activities and remote physios adjusting plans for best outcomes. All activities are journaled for easy follow-up.</Typography>
                                    <div style={{ marginTop: 8 }}>
                                        <Button onClick={() => setActiveStep((s) => Math.max(0, s - 1))} style={{ marginRight: 8, background: '#002D55', color: '#fff' }}>Back</Button>
                                        <Button variant="contained" onClick={() => setActiveStep((s) => Math.min(4, s + 1))} style={{ background: '#002D55', color: '#fff' }}>Next</Button>
                                    </div>
                                </StepContent>
                            </Step>
                            <Step>
                                <StepLabel StepIconComponent={CustomStepIcon}>Monitor progress and wellbeing in a simple dashboard.</StepLabel>
                                <StepContent>
                                    <Typography style={{ color: '#324158' }}>Track adherence, progress, and wellbeing in real-time. Care staff and remote physios can make data-driven decisions to optimize care and improve quality of life.</Typography>
                                    <div style={{ marginTop: 8 }}>
                                        <Button onClick={() => setActiveStep((s) => Math.max(0, s - 1))} style={{ marginRight: 8, background: '#002D55', color: '#fff' }}>Back</Button>
                                        <Button variant="contained" onClick={() => setActiveStep(0)} style={{ background: '#002D55', color: '#fff' }}>Finish</Button>
                                    </div>
                                </StepContent>
                            </Step>
                        </Stepper>
                    </div>

                    {/* Mobile horizontal stepper */}
                    <div className="mobile-stepper" style={{ display: 'none' }}>
                        <MobileStepper
                            variant="dots"
                            steps={5}
                            position="static"
                            activeStep={activeStep}
                            nextButton={<Button size="small" onClick={() => setActiveStep((s) => Math.min(4, s + 1))} style={{ background: '#002D55', color: '#fff' }}>Next</Button>}
                            backButton={<Button size="small" onClick={() => setActiveStep((s) => Math.max(0, s - 1))} style={{ background: '#002D55', color: '#fff' }}>Back</Button>}
                        />
                        <div style={{ marginTop: 12 }}>
                            <Typography style={{ color: '#324158' }}>
                                {activeStep === 0 && 'Register and onboard your clinic in minutes and get patients assigned or invite your own patients.'}
                                {activeStep === 1 && 'Pre-visit assessment writes the journal, guides triage and provides a clinically validated treatment program at your fingertips giving you a headstart that allows you to focus more on the patient in front of you.'}
                                {activeStep === 2 && 'Track patient progress, communicate securely, and adjust plans as needed.'}
                                {activeStep === 3 && 'Access analytics and reports to optimize care and business performance.'}
                            </Typography>
                        </div>
                    </div>
                </div>
            </Grid>
            <Grid item xs={12} style={{ margin: '32px 0 16px 0' }}>
                <Typography variant="h6" className={classes.headline} style={{ textAlign: 'center', width: '100%', marginLeft: 'auto', marginRight: 'auto' }}>
                    Ready to get started with VIRTUS<sup style={{fontSize: '0.7em', verticalAlign: 'super'}}>™</sup> Clinic? <br />
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    style={{ background: '#fb741a', color: '#fff', marginTop: 10, fontWeight: 600, fontSize: 18, padding: '10px 32px', borderRadius: 8, display: 'block', marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}
                    href="#contact"
                >
                    <span style={{ width: '100%', display: 'inline-block', textAlign: 'center' }}>SIGN UP</span>
                </Button>
                <div style={{ width: '100%', marginTop: 20, marginBottom: 8 }}></div>
            </Grid>

            {/* FAQ Section */}
            <Grid item xs={12} className={classes.section} style={{ maxWidth: 900, margin: '32px auto', marginBottom: 88, paddingLeft: 24, boxShadow: '0 6px 18px rgba(0,0,0,0.52)' }}>
                <Typography variant="h5" className={classes.headline} style={{ textAlign: 'center', marginBottom: 18 }}>
                    Frequently Asked Questions
                </Typography>
                {faqs.map((faq, idx) => (
                    <div key={idx} style={{ marginBottom: 10 }}>
                        <Button
                            onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                            style={{
                                color: '#002D55',
                                fontWeight: 600,
                                textTransform: 'none',
                                fontSize: 17,
                                justifyContent: 'flex-start',
                                width: '100%',
                                textAlign: 'left',
                                padding: '8px 0',
                                borderBottom: '1px solid #e0e0e0',
                                borderRadius: 0,
                                background: 'none',
                                boxShadow: 'none',
                            }}
                            aria-expanded={openFaq === idx}
                            aria-controls={`faq-panel-${idx}`}
                        >
                            {faq.q}
                        </Button>
                        <Collapse in={openFaq === idx} timeout="auto" unmountOnExit>
                            <div id={`faq-panel-${idx}`} style={{ color: '#324158', fontSize: 16, padding: '8px 0 8px 16px', background: '#f5f7fa', borderRadius: 4, marginBottom: 18 }}>
                                {faq.a}
                            </div>
                        </Collapse>
                    </div>
                ))}
            </Grid>

            
        </Grid>
    );
}
